export enum QueryKind {
    UNKNOWN,
    SELECT,
    INSERT,
    UPDATE,
    DELETE
}